module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@shopify/draggable");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external {"commonjs":"@shopify/draggable","commonjs2":"@shopify/draggable","amd":"Draggable","root":"Draggable"}
var draggable_amd_Draggable_root_Draggable_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/draggable-mixin.js
var events = [// draggable events
'draggable:initialize', 'draggable:destroy', 'drag:start', 'drag:move', 'drag:over', 'drag:over:container', 'drag:out', 'drag:out:container', 'drag:stop', 'drag:stopped', 'drag:pressure', // plugin events
'mirror:create', 'mirror:created', 'mirror:attached', 'mirror:move', 'mirror:destroy', 'collidable:in', 'collidable:out', 'snap:in', 'snap:out'];
/* harmony default export */ var draggable_mixin = ({
  provide: function provide() {
    return {
      draggable: this
    };
  },
  data: function data() {
    this.containers = [];
    this.draggableInstance = null;
    return {};
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pluginEvents: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    options: function options() {
      this.createInstanceBindEvents();
    },
    pluginEvents: function pluginEvents() {
      // TODO: optimize
      this.createInstanceBindEvents();
    }
  },
  methods: {
    createInstance: function createInstance() {},
    createInstanceBindEvents: function createInstanceBindEvents() {
      var _this = this;

      this.createInstance();
      events.forEach(function (eventName) {
        _this.draggableInstance.on(eventName, function (event) {
          _this.$emit(eventName, event);
        });
      });
      this.pluginEvents.forEach(function (eventName) {
        _this.draggableInstance.on(eventName, function (event) {
          _this.$emit(eventName, event);
        });
      });
    }
  },
  created: function created() {
    this.createInstanceBindEvents();
  },
  destroyed: function destroyed() {
    this.draggableInstance.destroy();
    this.draggableInstance = null;
  }
});
// CONCATENATED MODULE: ./src/draggable/Draggable.js


/* harmony default export */ var Draggable = ({
  name: 'VueDraggable',
  mixins: [draggable_mixin],
  data: function data() {
    return {};
  },
  methods: {
    createInstance: function createInstance() {
      if (this.draggableInstance) {
        this.containers = this.draggableInstance.containers;
        this.draggableInstance.destroy();
      }

      this.draggableInstance = new draggable_amd_Draggable_root_Draggable_["Draggable"](this.containers, this.options);
    }
  },
  render: function render(createElement) {
    if (this.tag === '') {
      return this.$slots.default[0];
    }

    return createElement(this.tag, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./src/draggable/index.js


Draggable.install = function (Vue) {
  Vue.component(Draggable.name, Draggable);
};

/* harmony default export */ var draggable = (Draggable);
// CONCATENATED MODULE: ./src/draggable-container/DraggableContainer.js
var errorMsg = "Can't get the injected object `draggable`, DraggableContainer only be used in Draggable, Droppable, Sortable or Swappable";
/* harmony default export */ var DraggableContainer = ({
  name: 'VueDraggableContainer',
  inject: ['draggable'],
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  mounted: function mounted() {
    if (this.draggable) {
      this.draggable.draggableInstance.addContainer(this.$el);
    } else {
      // eslint-disable-next-line no-console
      console.error(errorMsg);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.draggable) {
      this.draggable.draggableInstance.removeContainer(this.$el);
    } else {
      // eslint-disable-next-line no-console
      console.error(errorMsg);
    }
  },
  render: function render(createElement) {
    if (this.tag === '') {
      return this.$slots.default[0];
    }

    return createElement(this.tag, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./src/draggable-container/index.js


DraggableContainer.install = function (Vue) {
  Vue.component(DraggableContainer.name, DraggableContainer);
};

/* harmony default export */ var draggable_container = (DraggableContainer);
// CONCATENATED MODULE: ./src/droppable/Droppable.js


var Droppable_events = ['droppable:start', 'droppable:dropped', 'droppable:returned', 'droppable:stop'];
/* harmony default export */ var Droppable = ({
  name: 'VueDroppable',
  mixins: [draggable_mixin],
  provide: function provide() {
    return {
      draggable: this
    };
  },
  methods: {
    createInstance: function createInstance() {
      var _this = this;

      if (this.draggableInstance) {
        this.containers = this.draggableInstance.containers;
        this.draggableInstance.destroy();
        this.draggableInstance = null;
      }

      this.draggableInstance = new draggable_amd_Draggable_root_Draggable_["Droppable"](this.containers, this.options);
      Droppable_events.forEach(function (eventName) {
        _this.draggableInstance.on(eventName, function (event) {
          _this.$emit(eventName, event);
        });
      });
    }
  },
  render: function render(createElement) {
    if (this.tag === '') {
      return this.$slots.default[0];
    }

    return createElement(this.tag, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./src/droppable/index.js


Droppable.install = function (Vue) {
  Vue.component(Droppable.name, Droppable);
};

/* harmony default export */ var droppable = (Droppable);
// CONCATENATED MODULE: ./src/sortable/Sortable.js


var Sortable_events = ['sortable:start', 'sortable:sort', 'sortable:sorted', 'sortable:stop'];
/* harmony default export */ var Sortable = ({
  name: 'VueSortable',
  mixins: [draggable_mixin],
  methods: {
    createInstance: function createInstance() {
      var _this = this;

      if (this.draggableInstance) {
        this.containers = this.draggableInstance.containers;
        this.draggableInstance.destroy();
        this.draggableInstance = null;
      }

      this.draggableInstance = new draggable_amd_Draggable_root_Draggable_["Sortable"](this.containers, this.options);
      Sortable_events.forEach(function (eventName) {
        _this.draggableInstance.on(eventName, function (event) {
          _this.$emit(eventName, event);
        });
      });
    }
  },
  render: function render(createElement) {
    if (this.tag === '') {
      return this.$slots.default[0];
    }

    return createElement(this.tag, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./src/sortable/index.js


Sortable.install = function (Vue) {
  Vue.component(Sortable.name, Sortable);
};

/* harmony default export */ var sortable = (Sortable);
// CONCATENATED MODULE: ./src/swappable/Swappable.js


var Swappable_events = ['swappable:start', 'swappable:swap', 'swappable:swapped', 'swappable:stop'];
/* harmony default export */ var Swappable = ({
  name: 'VueSwappable',
  mixins: [draggable_mixin],
  methods: {
    createInstance: function createInstance() {
      var _this = this;

      if (this.draggableInstance) {
        this.containers = this.draggableInstance.containers;
        this.draggableInstance.destroy();
        this.draggableInstance = null;
      }

      this.draggableInstance = new draggable_amd_Draggable_root_Draggable_["Swappable"](this.containers, this.options);
      Swappable_events.forEach(function (eventName) {
        _this.draggableInstance.on(eventName, function (event) {
          _this.$emit(eventName, event);
        });
      });
    }
  },
  render: function render(createElement) {
    if (this.tag === '') {
      return this.$slots.default[0];
    }

    return createElement(this.tag, this.$slots.default);
  }
});
// CONCATENATED MODULE: ./src/swappable/index.js


Swappable.install = function (Vue) {
  Vue.component(Swappable.name, Swappable);
};

/* harmony default export */ var swappable = (Swappable);
// CONCATENATED MODULE: ./src/index.js
/* global PKG_VERSION */





var components = [draggable, draggable_container, droppable, sortable, swappable];

var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

/* harmony default export */ var src = __webpack_exports__["default"] = ({
  version: "0.0.2",
  install: install,
  Draggable: draggable,
  DraggableContainer: draggable_container,
  Droppable: droppable,
  Sortable: sortable,
  Swappable: swappable
});

/***/ })
/******/ ])["default"];